export class SnackBarParams {
    duration: number ;
    redirectTitle: string = '';
    redirectUrl: string = '';
    snackBarContainerId: string ;
    url: string;
    isMessageTranslated: boolean = true;
    isTitleTranslated: boolean = true;
    
    constructor(redirectUrl: string = "", redirectText: string = "") {
        this.redirectTitle = redirectText;
        this.redirectUrl = redirectUrl;
        this.duration = 3000;
        this.snackBarContainerId = 'snackBarContainer';
        this.url = `${window.location.pathname}?handler=snackbar`;
    }
}